import { colors } from '../foundation';

type Props = {
  color: (typeof colors.monochrome)['6'] | (typeof colors.monochrome.inverse)['6'];
};

const ChevronLeft = ({ color }: Props) => {
  return (
    <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5416 17.0833L10.4583 9.99999L17.5416 2.91666"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
};
export default ChevronLeft;
